export const PUB_ADS_SERVICE_REFRESH_KNOWLEDGE_BASE =
  'https://knowledge-base.yieldbird.com/yieldbird-platform/pubadsservicerefresh-function-control'
